import axios from '../../localAxios';
import { WorkspaceRole } from '../getWorkspaceMembers';
import { workspaceCodeStatusesURL } from '../workspacesURLs';

export interface WorkspaceCodeStatus {
  role: WorkspaceRole;
  active: boolean;
}

interface WorkspaceCodeStatusesResponse {
  statuses: WorkspaceCodeStatus[];
}

/**
 * Per-role invite-link existence for a library (booleans only — no codes).
 * Powers the invite dialog's status badges, including roles above the current
 * user that they can't otherwise read a link for.
 */
export async function getWorkspaceCodeStatuses(
  workspaceId: string
): Promise<WorkspaceCodeStatus[]> {
  const url = workspaceCodeStatusesURL(workspaceId);
  const response = await axios.get<WorkspaceCodeStatusesResponse>(url.href);
  return response.data.statuses;
}
